import { type ApiClientResponse, apiClient, routes } from 'common/services';

export type UpdateNotificationSettingRequest = {
  notifications: {
    badge_notifications_settings: {
      enable_notifications: boolean;
    };
    email_notifications_settings: {
      enable_notifications: boolean;
      events: boolean;
      giving: boolean;
      newsfeed: boolean;
      program: boolean;
    };
    push_notifications_settings: {
      enable_notifications: boolean;
      events: boolean;
      giving: boolean;
      messaging: boolean;
      newsfeed: boolean;
      program: boolean;
    };
  };
  userId: string;
};

export const updateNotificationsSettings = async ({ notifications, userId }: UpdateNotificationSettingRequest) => {
  const updateUser = {
    user: {
      ...notifications,
    },
  };

  return apiClient.patch<unknown, ApiClientResponse<unknown>>(routes.user.patch(userId), updateUser);
};
